import { BiCoin } from 'react-icons/bi';
import { GOLD_COLOR } from '../../constants';

const GoldenCoinIcon = () => {
  return <BiCoin color={GOLD_COLOR} />;
};

export default GoldenCoinIcon;
